import React, { Component } from 'react';
import {getJobsList, removeCouponItem} from '../../modules/Api';
import ReactTable from 'react-table';
import history from '../../modules/History';
import { Button, notification } from 'antd';
import { END_POINT } from '../../constants/config';
import ACL from '../../components/ACL';

class Jobs extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = (query = '') => {
        getJobsList(query, (res) => {this.setState({
            items: res.data.data,
            last_page: res.data.last_page,
            count: res.data.total,
            pageSize: res.data.per_page
        }
        )});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        let sort = {
            order: 'desc',
            field: 'created_at',
        };
        if(state.sorted.length > 0) {
            sort = {
                order: state.sorted[0].desc ? 'desc': 'asc',
                field: state.sorted[0].id,
            }
        }

        let filterQuery = state.filtered.reduce((q, item) => {
            return item.value ? `${q}&${item.id}=${item.value}` : q;
        }, '');

        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&${filterQuery}&sort=${JSON.stringify(sort)}`;
        this.fetchData(query);
    }

    removeCoupon(id) {
        const warningMessage = `آیا از حذف فرصت شغلی اطمینان کامل دارید ؟ تمام اطلاعات مرتبط با آن حذف می شوند !`;
        if (window.confirm(warningMessage)) {
            removeCouponItem(id, () => {
                notification.open({
                    message: `فرصت شغلی با موفقیت حذف شد!`,
                    description: `تمامی اطلاعات فرصت شغلی با موفقیت حذف شدند.`
                })
            });
            this.fetchData();
        }
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
                filterable: true,
            },
            {
                Header: 'عنوان',
                accessor: 'title',
                filterable: true,
                Cell: (row) => (<ACL component="div" has_permission="coupons_management|coupons_edit" denied={() => {return row.original.title;}} ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}} title={row.original.title} onClick={() => {window.open(`/jobs/edit/${row.original.id}`, "_blank")}}> {row.original.title} </span></ACL>)
            },
            {
                Header: 'وضعیت',
                accessor: 'status',
                filterable: true,
                Cell: (row) => (<span title={row.original.plan_enum_title}> {row.original.plan_enum_title} </span>),
                Filter: ({ filter, onChange }) =>
                    <select
                      onChange={event => onChange(event.target.value)}
                      style={{ width: "100%" }}
                      value={filter ? filter.value : null}
                    >
                      <option></option>
                      <option value="0">غیرفعال</option>
                      <option value="1">فعال</option>
                    </select>
            },
            {
                Header: 'عملیات',
                accessor: 'delete',
                sortable: false,
                Cell: (row) => (
                    <React.Fragment>
                        <ACL component="span" has_permission="coupons_management|coupons_delete"><span onClick={() => {this.removeCoupon(row.original.id)}} style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X </span></ACL>
                        <ACL component="span" has_permission="coupons_management|coupons_history"><span onClick={() => history.item.push(`/history/coupon/${row.original.id}`)} className="link">H</span></ACL>
                    </React.Fragment>
                )
            },

        ]
        return(
            <div style={{textAlign: 'center'}}>
                <div className="btn-container">
                    <ACL component="div" has_permission="coupons_management|coupons_add"><Button type="primary" onClick={() => history.item.push(`/jobs/create`)}>افزودن فرصت شغلی جدید</Button></ACL>
                </div>

                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default Jobs;



// WEBPACK FOOTER //
// ./src/containers/Jobs/index.js